import { render, staticRenderFns } from "./PublisherAlert.vue?vue&type=template&id=353a36b8"
import script from "./PublisherAlert.vue?vue&type=script&lang=js"
export * from "./PublisherAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports